module.exports = __webpack_public_path__ + "static/img/login.0a83f5f2.jpg";